var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.168 9.83366H9.83464V13.167H8.16797V9.83366H4.83464V8.16699H8.16797V4.83366H9.83464V8.16699H13.168V9.83366ZM9.0013 0.666992C7.90695 0.666992 6.82332 0.88254 5.81227 1.30133C4.80123 1.72012 3.88257 2.33395 3.10875 3.10777C1.54594 4.67057 0.667969 6.79019 0.667969 9.00033C0.667969 11.2105 1.54594 13.3301 3.10875 14.8929C3.88257 15.6667 4.80123 16.2805 5.81227 16.6993C6.82332 17.1181 7.90695 17.3337 9.0013 17.3337C11.2114 17.3337 13.3311 16.4557 14.8939 14.8929C16.4567 13.3301 17.3346 11.2105 17.3346 9.00033C17.3346 7.90598 17.1191 6.82234 16.7003 5.8113C16.2815 4.80025 15.6677 3.88159 14.8939 3.10777C14.12 2.33395 13.2014 1.72012 12.1903 1.30133C11.1793 0.88254 10.0957 0.666992 9.0013 0.666992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAdd);
export default __webpack_public_path__ + "static/media/plusAdd.87dfefb5eda6ca9f8481968549ede1ca.svg";
export { ForwardRef as ReactComponent };